import React, { useEffect, useState } from 'react';
import './Gallery.css';
import { useHistory } from 'react-router-dom';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { CircularProgress } from '@mui/material';
import axios from 'axios';
import { apilink } from '../../data/fdata';
import Cookies from 'js-cookie';
import SideBar from '../../component/sidebar/SideBar';
const Gallery = () => {
  const his = useHistory();
  const hecord_tokon = Cookies.get('_hecord_access_user_tokon_');
  const [sortitem, setSortItem] = useState('');
  const [uploadstatus, setUploadstatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [postimg, setPostimg] = useState([]);
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);
  const handelImg = (e) => {
    const { files } = e.target;
    if (files.length > 0) {
      setPostimg(files[0]);
    }
  };
  const onsub = () => {};

  useEffect(async () => {
    const res = await axios.get(`${apilink}/auth/isVerify`, {
      headers: {
        Authorization: hecord_tokon,
      },
    });
    // console.log(res.data);
    if (!res.data.success) {
      his.push('/');
    }
  }, []);
  return (
    <>
      <div className="whole__page">
        <div className="left_side_navbar">
          <SideBar />
        </div>
        <div className="main_div ">
          <div className="main_inner_div">
            <div className="class_cen_80">
              <div className="container">
                <div className="file_feature_up">
                  <div className="file_feature_inn">
                    <button
                      className="btn btn-onee-mix"
                      onClick={() => setUploadstatus(true)}
                    >
                      <div className="dflex">
                        <CloudUploadIcon />{' '}
                        <span> &nbsp; &nbsp; Upload File</span>
                      </div>
                    </button>

                    <div class="form-group">
                      <select
                        class="form-control"
                        onChange={(e) => setSortItem(e.target.value)}
                      >
                        <option selected hidden>
                          --Sort Option--
                        </option>
                        <option value="all">All</option>
                        <option value="name">ByName</option>
                        <option value="date">ByDate</option>
                      </select>
                    </div>
                  </div>
                </div>
                <br />
                <div className="text-center">
                  <h4>
                    Place to store any physical files like - test reports,
                    prescriptions, important bills etc
                  </h4>
                </div>

                <div className="row">
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((val) => {
                    return (
                      <>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12  mb-3">
                          <div className="card p-2">
                            <img
                              src="https://images.unsplash.com/photo-1538991383142-36c4edeaffde?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8ZnJlZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
                              alt=""
                              className="file_img"
                            />
                            <p className="p_mar">Image Name</p>

                            <div className="box">
                              <p className="p_mar">12/12/2022</p>
                              <i className="fa fa-trash text-danger cur"></i>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>

              {uploadstatus && (
                <div className="modbox">
                  <div className="sm_box p-4">
                    <div
                      className="btn_close"
                      onClick={() => setUploadstatus(false)}
                    >
                      X
                    </div>
                    <h5 className="text_blue">Upload File</h5>
                    <form action="" className="pt-2" onSubmit={onsub}>
                      <div class="form-group">
                        <input
                          type="file"
                          class="form-control"
                          onChange={handelImg}
                          required
                        />
                      </div>
                      <div className="text-center">
                        <button
                          type="submit"
                          className={
                            loading ? 'dis btn btn-primary' : 'btn btn-primary'
                          }
                          disabled={loading}
                        >
                          Upload File
                        </button>
                      </div>
                      {loading && (
                        <div className="text-center p-2">
                          <CircularProgress color="success" size={35} />
                        </div>
                      )}
                    </form>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Gallery;
